import React from 'react';
import { fetchJson } from '../../helpers/index.js';

import {
  datagrid_form_context_definitions_path,
  datagrid_get_flattened_rows_path
} from '~/routes';

export const FormContext = React.createContext({
  programmeId: null,
  projectId: null
});

export const getDefaultContext = () => {
  return {
    programmeId: document.body.getAttribute('data-programme-id'),
    /*
     * Indicator component requires project_id.
     * Currently only reports support indicator components
     */
    projectId: document.querySelector('#report-container')?.getAttribute('data-project-id'),
    loading: true
  }
}

export const loadDatagridContext = async ({programmeFormLinkId, programmeFormId, projectId, publicContext}, opts = {loadPresetValues: false}) => {
  // console.log("!", programmeFormLinkId, programmeFormId, projectId)
  // Called from invalid context.
  // TODO: Add necessary publicContext to wanted form type (currently survey has this)
  if ((!programmeFormLinkId && !programmeFormId) || publicContext) {
    return {
      programmeFormId,
      loading: false
    }
  }
  const getDefinitionsBy = programmeFormLinkId ? {programme_form_link_id: programmeFormLinkId} : {programme_form_id: programmeFormId}
  const definitions = await fetchJson(datagrid_form_context_definitions_path(getDefinitionsBy))

  let rows = {}

  if (opts.loadPresetValues) {
    let promises = []
    definitions.forEach(definition => {
      definition.presets.forEach(preset => {
        promises.push(
          fetchJson(datagrid_get_flattened_rows_path({
            id: definition.id,
            project_id: projectId,
            preset_id: preset.id,
            programme_form_id: programmeFormId,
            _options: true
          }), {method: 'POST'}).then(res => {
            rows[definition.id] = rows[definition.id] || {};
            rows[definition.id][preset.id] = res;
          })
        )
      })
    })
    
    await Promise.all(promises)
  }

  return {
    loading: false,
    datagridContext: definitions,
    datagridRows: rows, // Rows in {<datagrid_id>: {<preset_id>: [Rows]}}
    programmeFormId
  }
}
